export default "__VITE_ASSET__DjYE6keK__"